import React, { useState, useEffect } from 'react';
import { Box, TextField, Button, MenuItem } from '@mui/material';
import koLocale from 'date-fns/locale/ko';
import DateAdapter from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';

//----------------------------------------------------

// 메뉴 필터링 함수 (admin: true 제거)
export const filterAdminMenus = (menuList) => {
  return menuList
    .filter((menu) => !menu?.admin) // 1단계 필터링
    .map((menu) => ({
      ...menu,
      // 하위 items가 있다면 재귀적으로 필터링, 없으면 빈 배열
      items: menu.items ? filterAdminMenus(menu.items) : [],
    }));
};

export const ProjectOrdersListBox = ({ formik }) => {
  const [searchStrtDt, setSearchStrtDt] = useState(null);
  const [searchEndDt, setSearchEndDt] = useState(null);

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const firstDayOfYear = new Date(currentYear, 0, 1); // 1월 1일
    const lastDayOfYear = new Date(currentYear, 11, 31); // 12월 31일

    // 시작일 초기값 설정 (값이 없을 때만)
    if (!formik.values.searchStrtDt) {
      formik.setFieldValue('searchStrtDt', firstDayOfYear);
      setSearchStrtDt(firstDayOfYear);
    } else {
      setSearchStrtDt(formik.values.searchStrtDt);
    }

    // 종료일 초기값 설정 (값이 없을 때만)
    if (!formik.values.searchEndDt) {
      formik.setFieldValue('searchEndDt', lastDayOfYear);
      setSearchEndDt(lastDayOfYear);
    } else {
      setSearchEndDt(formik.values.searchEndDt);
    }
  }, [formik.values.searchStrtDt, formik.values.searchEndDt]);

  const onChangeDate = (newValue, name) => {
    formik.setFieldValue(name, newValue);
  };

  return (
    <div>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'flex-start',
          alignItems: 'center',
          my: 1,
        }}
      >
        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            alignItems: 'center',
            mr: 2,
          }}
          onSubmit={formik.handleSubmit}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'center',
              '& > :not(style)': { m: 1, width: '25ch' },
            }}
          >
            <TextField
              variant="standard"
              required={false}
              select
              id="searchKeyword"
              name="searchKeyword"
              label="검색키워드"
              value={formik.values.searchKeyword}
              onChange={formik.handleChange}
              error={
                formik.touched.searchKeyword &&
                Boolean(formik.errors.searchKeyword)
              }
              helperText={
                formik.touched.searchKeyword && formik.errors.searchKeyword
              }
            >
              <MenuItem value="prjNo">프로젝트 번호</MenuItem>
              <MenuItem value="cstNm">사업명</MenuItem>
              <MenuItem value="partnerNm">매출처명</MenuItem>
            </TextField>
            <TextField
              variant="standard"
              required={false}
              id="searchWords"
              name="searchWords"
              label="검색어"
              value={formik.values.searchWords}
              onChange={formik.handleChange}
              error={
                formik.touched.searchWords && Boolean(formik.errors.searchWords)
              }
              helperText={
                formik.touched.searchWords && formik.errors.searchWords
              }
            />
          </Box>
          <Box>
            <LocalizationProvider dateAdapter={DateAdapter} locale={koLocale}>
              <DatePicker
                label="수주 계약일"
                inputFormat={'yyyy-MM-dd'}
                mask={'____-__-__'}
                id="searchStrtDt"
                name="searchStrtDt"
                value={searchStrtDt}
                onChange={(newValue) => {
                  setSearchStrtDt(newValue);
                  onChangeDate(newValue, 'searchStrtDt');
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    fullWidth
                    error={
                      formik.touched.searchStrtDt &&
                      Boolean(formik.errors.searchStrtDt)
                    }
                    helperText={
                      formik.touched.searchStrtDt && formik.errors.searchStrtDt
                    }
                  />
                )}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ mx: 2 }}>
            <LocalizationProvider dateAdapter={DateAdapter} locale={koLocale}>
              <DatePicker
                label="수주 계약일"
                inputFormat={'yyyy-MM-dd'}
                mask={'____-__-__'}
                id="searchEndDt"
                name="searchEndDt"
                value={searchEndDt}
                onChange={(newValue) => {
                  setSearchEndDt(newValue);
                  onChangeDate(newValue, 'searchEndDt');
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    fullWidth
                    error={
                      formik.touched.searchEndDt &&
                      Boolean(formik.errors.searchEndDt)
                    }
                    helperText={
                      formik.touched.searchEndDt && formik.errors.searchEndDt
                    }
                  />
                )}
              />
            </LocalizationProvider>
          </Box>
          <Box>
            <Button
              type="submit"
              color="info"
              variant="contained"
              disabled={formik.isSubmitting}
            >
              검색
            </Button>
          </Box>
        </Box>
      </Box>
    </div>
  );
};
